import { RootState } from '@store/rootReducer'
export const selectZoomRatio = (state: RootState) => state.editor.editor.zoomRatio
export const selectIsOpenErrorModalRemoveBg = (state: RootState) =>
  state.editor.editor.isOpenErrorModalRemoveBg
export const selectHasClipboardImage = (state: RootState) => state.editor.editor.hasClipboardImage
export const selectCallbackFromCreationPage = (state: RootState) =>
  state.editor.editor.callbackFromCreationPage
export const selectDisableEditorState = (state: RootState) => state.editor.editor.disableEditorState
export const selectEditorState = (state: RootState) => state.editor.editor.editorState
export const selectIsOpenInspector = (state: RootState) => state.editor.editor.isOpenInspector
export const selectLoaderText = (state: RootState) => state.editor.editor.editorState.loaderText
export const selectCanvasInteractionState = (state: RootState) => state.editor.editor.canvasInteractionState
